<template>
  <div>
    <div style="text-align: end;">
      <a-button class="header-btn"
                v-bind="action.props"
                @click.prevent="() => {action.fnLoading && action.fnLoading(); handleEvents({action: action.name, _action:action})}"
                v-for="action in headerActions"
                v-if="action.fnVisible ? action.fnVisible() : true"
                :loading="action.fnLoading ? action.fnLoading() : false">
        {{action.text}}
      </a-button>
      <slot name="customButton">

      </slot>
    </div>
    <g-datatable :columns="tableSetup.columns"
                 :endpoint="endpoint"
                 :tableConfig.sync="tableSetup.tableConfig"
                 :allowSelect="tableSetup.allowSelect"
                 :selectType="tableSetup.selectType"
                 :selectedRowKeys.sync="tableSetup.selectedRowKeys"
                 :selectedRows.sync="tableSetup.selectedRows"
                 :actions="tableSetup.actions"
                 :fnSelectionDisabled="tableSetup.fnSelectionDisabled"
                 v-on:action="handleEvents"
                 :requestData="parentData"
                 :customSlots="tableSetup.customSlots"
                 @params="paramsTable"
                 @selectAll="selectAll"
                 ref="datatable">
      <template v-for="customSlot in tableSetup.customSlots" :slot="customSlot"
                slot-scope="{text, record, index}">
        <slot :name="customSlot" v-bind:text="text" v-bind:record="record" v-bind:index="index"></slot>
      </template>
    </g-datatable>

    <a-modal title="Crear / Editar"
             :visible="modal.visible"
             @ok="handleModalOk"
             @cancel="handleModalCancel"
             :confirmLoading="modal.loading"
             :width="modalWidth || 600">
      <a-form :form="modal.form" @submit="handleModalOk" v-on:keyup.enter="handleModalOk">
        <slot name="masterModal" v-bind:record="record" v-bind:error="error"></slot>
      </a-form>
      <a-alert v-if="modal.error"
               message="Error"
               type="error"
               :closable="true"
               @close="errorClose">
        <div slot="description" v-html="modal.mensaje"></div>
      </a-alert>
    </a-modal>

    <a-modal title="Confirmación"
             :visible="modal.deleteVisible"
             @ok="handleModalDelete"
             @cancel="handleModalCancel"
             :confirmLoading="modal.loading"
             :width="600"
             okType="danger">
      <slot name="masterDeleteModal" v-bind:record="record" v-bind:error="error">
        ¿Está seguro que desea eliminar el registro?
      </slot>
      <a-alert v-if="modal.error"
               message="Error"
               type="error"
               :closable="true"
               @close="errorClose">
        <div slot="description" v-html="modal.mensaje"></div>
      </a-alert>
    </a-modal>
  </div>
</template>
<script>
  import JsUtils from '@/util/JsUtils'
  import HttpUtil from '@/util/HttpUtil'
  import DateUtils from '@/util/DateUtils'
  import Mensajes from 'CustomModules/GlobalBPOCore/Util/Mensajes'

  export default {
    /**
     * actions debe tener el formato:
     * [
     *      { name: xxxx, text: xxxx, icon: xxxx, permisos: [], props: {}  }
     * ]
     * Permisos es un vector de permisos si el usuario tiene alguno de los permisos se muestra el boton
     * Las props se pasan directamente al boton
     *
     * isSpResponse indica si es el resultado de un procedimiento almacenado. espera: resultado = 2 para tomar como ok.
     *
     * modalFieldsSetup: Es la configuración del formumlario dentro del modal. Si es especifica este campo se llamará a getFieldDecorator para estos campos
     * y solo se llenará el modal con estos valores. De lo contrario se pondrá todo el registro en el modal.
     [
     {
         name: 'field_id' //ES EL ID UTILZIADO EN EL DECORADOR
         type: undefined|date|time //POR EL MOMENTO SOLO SE ESPERA DATE TIME O UNDEFINED. EL TIPO DATE y TIME SERÁ CONVERTIDO A MOMENT AL MOMENTO DE EDITAR.
     }
     ]
     * useMultipart: indica si debe utilizar o no una peticion del tipo multipart/form-data para subir archivos,
     * se debe usar beforeSend para llenar los archivos. La peticion será convertida a FormData
     * beforeSend: es una funcion que recibe y transforma los datos antes de enviar al backend. Un ejemplode uso es para subir archivos.
     */
    props: ['name', 'endpoint', 'tableSetup', 'actions', 'modalWidth', 'parentData', 'isSpResponse', 'modalFieldsSetup', 'useMultipart', 'beforeSend'],
    data () {
      return {
        headerActions: this.actions !== false ? (this.actions || [
          {name: 'masterCreate', text: 'Crear', permisos: [], props: {icon: 'plus', type: 'button'}, fnVisible: () => !this.$userIsInrol('Query')}
        ]) : [],
        record: {},
        error: {},
        modal: {
          visible: false,
          deleteVisible: false,
          form: {},
          error: false,
          mensaje: '',
          loading: false
        },
        rowKey: '',
        modalFieldsSetupDataTypes: {},
        lastChangeEmited: undefined
      }
    },
    beforeMount () {
      this.modal.form = this.$form.createForm(this, {
        name: this.name,
        onFieldsChange: (_, changedFields) => {
          /* Debido a que ant vue por diseño emite 2 veces el mismo evento solo emitimos el primero el segundo lo ignoramos */
          if (typeof this.lastChangeEmited === 'undefined') {
            this.lastChangeEmited = moment()
          } else {
            /* esperamos 50 milisegundos entre eventos para no emitir */
            let diff = moment().diff(this.lastChangeEmited)
            if (diff < 50) {
              return
            }
          }
          this.lastChangeEmited = moment()
          this.$emit('fieldsChange', changedFields)
          this.handleEvents({
            action: 'fieldsChange',
            changedFields: changedFields
          })
        }
      })
      if (this.tableSetup.actions !== false) {
        this.tableSetup.actions = {
          title: 'Acciones',
          scopedSlots: {customRender: 'hooverableAction'},
          width: 100,
          fixed: 'right',
          actions: [
            {
              name: 'masterEdit',
              text: 'Editar',
              permisos: [],
              props: {size: 'small', type: 'link', icon: 'edit'},
              fnVisible: () => !this.$userIsInrol('Query')
            },
            {
              name: 'masterDelete',
              text: 'Eliminar',
              permisos: [],
              props: {size: 'small', icon: 'delete', type: 'link'},
              fnVisible: () => !this.$userIsInrol('Query')
            }
          ],
          ...this.tableSetup.actions
        }
      } else {
        this.tableSetup.actions = null
      }
      // this.tableSetup.requestData = this.tableSetup.requestData || this.parentData || {}
    },
    mounted () {
      this.tmp = this
      this.rowKey = this.tableSetup.tableConfig.rowKey
      this.http = new HttpUtil(this.endpoint)
      if (!JsUtils.isEmpty(this.modalFieldsSetup)) {
        this.modalFieldsSetup.map((field) => {
          this.modal.form.getFieldDecorator(field.name)
        })
      }
      if (!JsUtils.isEmpty(this.modalFieldsSetup)) {
        this.modalFieldsSetup.map((field) => {
          this.modalFieldsSetupDataTypes[field.name] = field.type
        })
      }
    },
    methods: {
      paramsTable (params) {
        this.$emit('params', params)
      },
      masterEdit (data, callbackFn) {
        this.modal.visible = true
        this.record = data.record
        this.$nextTick(() => {
          let nData = {}

          if (!JsUtils.isEmpty(this.modalFieldsSetup)) {
            this.modalFieldsSetup.map((field) => {
              switch (field.type) {
                case 'date':
                  if (!JsUtils.isEmpty(data.record[field.name])) {
                    nData[field.name] = moment(data.record[field.name])
                  } else {
                    nData[field.name] = null
                  }
                  break
                case 'time':
                  if (!JsUtils.isEmpty(data.record[field.name])) {
                    let time = data.record[field.name].split(':')
                    nData[field.name] = moment().set('hour', time[0]).set('minute', time[1])
                  } else {
                    nData[field.name] = null
                  }
                  break
                default:
                  nData[field.name] = data.record[field.name]
                  break
              }
            })
          } else {
            for (let prop in data.record) {
              if (data.record.hasOwnProperty(prop)) {
                nData[prop] = data.record[prop]
              }
            }
          }

          this.modal.form.setFieldsValue(nData)
          callbackFn && callbackFn()
        })
      },
      masterDelete (data, callbackFn) {
        this.modal.deleteVisible = true
        this.record = data.record
        callbackFn && callbackFn()
      },
      masterCreate (record, callbackFn) {
        this.modal.visible = true
        this.record = {}
        this.$nextTick(() => {
          this.modal.form.resetFields()
          callbackFn && callbackFn()
        })
      },
      handleEvents (data) {
        if (!JsUtils.isEmpty(data.action) && !JsUtils.isEmpty(this[data.action])) {
          this[data.action](data, () => {
            this.$emit('action', data)
          })
        } else {
          this.$emit('action', data)
        }
      },
      handleModalOk (e) {
        e.preventDefault()
        this.modal.form.validateFields((err, values) => {
          if (!err) {
            this.modal.loading = true

            let data = values
            if (!JsUtils.isEmpty(this.parentData)) {
              data = {...this.parentData, ...data}
            }

            for (let prop in data) {
              if (data.hasOwnProperty(prop)) {
                if (this.modalFieldsSetupDataTypes.hasOwnProperty(prop)) {
                  if (JsUtils.isEmpty(data[prop])) {
                    data[prop] = null
                  } else {
                    switch (this.modalFieldsSetupDataTypes[prop]) {
                      case 'date':
                        if (moment.isMoment(data[prop])) {
                          data[prop] = DateUtils.forBackEnd(data[prop])
                        } else {
                          alert('FECHA MAL ESTABLECIDA EN EL FORMULARIO DE EDICION')
                        }
                        break
                      case 'time':
                        if (moment.isMoment(data[prop])) {
                          data[prop] = data[prop].format('HH:mm')
                        } else {
                          alert('HORA MAL ESTABLECIDA EN EL FORMULARIO DE EDICION')
                        }
                        break
                    }
                  }
                } else {
                  if (moment.isMoment(data[prop])) {
                    data[prop] = DateUtils.forBackEnd(data[prop])
                  }
                }
              }
            }

            if (!JsUtils.isEmpty(this.beforeSend)) {
              data = this.beforeSend(data)
            }

            let afterSave = () => {
              this.modal.loading = false
            }

            let finalRequest = data
            if (this.useMultipart === true) {
              /* Se debe transformar la peticion en FormData */
              finalRequest = new FormData()

              for (let prop in data) {
                if (data.hasOwnProperty(prop)) {
                  if (!JsUtils.isEmpty(data[prop])) {
                    finalRequest.append(prop, data[prop])
                  } else {
                    finalRequest.append(prop, '')
                  }
                }
              }

              if (!JsUtils.isEmpty(this.record) && !JsUtils.isEmpty(this.record[this.rowKey])) {
                finalRequest.append('id', this.record[this.rowKey])
              }
            } else {
              if (!JsUtils.isEmpty(this.record) && !JsUtils.isEmpty(this.record[this.rowKey])) {
                finalRequest.id = this.record[this.rowKey]
              }
            }

            if (JsUtils.isEmpty(this.record) || JsUtils.isEmpty(this.record[this.rowKey])) {
              this.http.create(finalRequest, this.handleOkResponse, this.handleErrorResponse).then(afterSave)
            } else {
              this.http.update(finalRequest, this.handleOkResponse, this.handleErrorResponse).then(afterSave)
            }
          }
        })
      },
      handleModalCancel () {
        if (this.modal.loading) {
          return
        }
        this.modal.form.resetFields()
        this.modal.visible = false
        this.modal.deleteVisible = false
        this.modal.error = false
        this.modal.mensaje = ''
        this.error = {}
      },
      handleModalDelete () {
        this.modal.loading = true
        if (!JsUtils.isEmpty(this.record) && !JsUtils.isEmpty(this.record[this.rowKey])) {
          this.http.delete(this.record[this.rowKey], this.handleOkResponse, this.handleErrorResponse).then(() => {
            this.modal.loading = false
          })
        } else {
          this.modal.deleteVisible = false
          this.modal.loading = false
          this.handleModalCancel()
        }
      },
      handleOkResponse (response) {
        this.$emit('handleOk', response.data)
        if (this.isSpResponse === true) {
          if (parseInt(response.data.resultado) !== 2) {
            this.modal.error = true
            this.modal.mensaje = response.data.mensaje
            this.error = response.data
            return
          } else {
            Mensajes.success('Correcto', response.data.mensaje)
          }
        }
        this.modal.form.resetFields()
        this.modal.visible = false
        this.modal.deleteVisible = false
        this.modal.error = false
        this.modal.mensaje = ''
        this.error = {}
        this.$emit('handleOkResp')
        this.$refs.datatable.loadData()
      },
      handleErrorResponse (error) {
        this.modal.error = true
        this.modal.mensaje = this.$getErrorMessage(error)
        this.error = error
      },
      errorClose (e) {
        this.modal.error = false
      },
      selectAll (selected) {
        this.$emit('selectAll', selected)
      }
    },
    watch: {
      parentData (val) {
        this.$nextTick(() => {
          this.tableSetup.requestData = this.parentData
        })
      }
    }
  }
</script>
<style>
  .header-btn {
    margin-right: 8px !important;
    margin-bottom: 12px !important;
  }
</style>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/components/master-detail/master.vue